import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import PageBreadcrumb from "./PageBreadcrumb";
import { getPageBreadcrumbs } from "../../../utils/pageBreadcrumbs";

const CustomPageHeader = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const authUser = useSelector((state) => state.auth.user);
  const { firstName, lastName } = authUser || {};
  const userTypeFromRole = useSelector((state) => state.auth?.role?.name);
  const userTypeFromUser = authUser?.userType;
  const userType = userTypeFromRole || userTypeFromUser;

  const breadcrumbData = getPageBreadcrumbs({
    pathname: location.pathname,
    role: userType,
    t,
    i18n,
    firstName,
    lastName,
    locationState: location.state,
  });

  if (!breadcrumbData) {
    return null;
  }

  return (
    <PageBreadcrumb
      crumbs={breadcrumbData.crumbs}
      subtitle={breadcrumbData.subtitle}
    />
  );
};

export default CustomPageHeader;
